import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

export const HomeIcon: FunctionComponent<IIconProps> = ({ ...props }) => (
  <Icon {...{ viewBox: '0 0 18 19', fillOpacity: 0, ...props }}>
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.25 15.4859V9.48594C10.25 9.28703 10.171 9.09626 10.0303 8.95561C9.88968 8.81496 9.69891 8.73594 9.5 8.73594H6.5C6.30109 8.73594 6.11032 8.81496 5.96967 8.95561C5.82902 9.09626 5.75 9.28703 5.75 9.48594V15.4859M1.25 7.23594C1.24995 7.01774 1.2975 6.80215 1.38934 6.60423C1.48118 6.4063 1.6151 6.23079 1.78175 6.08994L7.03175 1.59069C7.30249 1.36187 7.64552 1.23633 8 1.23633C8.35448 1.23633 8.69751 1.36187 8.96825 1.59069L14.2183 6.08994C14.3849 6.23079 14.5188 6.4063 14.6107 6.60423C14.7025 6.80215 14.7501 7.01774 14.75 7.23594V13.9859C14.75 14.3838 14.592 14.7653 14.3107 15.0466C14.0294 15.3279 13.6478 15.4859 13.25 15.4859H2.75C2.35218 15.4859 1.97064 15.3279 1.68934 15.0466C1.40804 14.7653 1.25 14.3838 1.25 13.9859V7.23594Z"
    />
  </Icon>
)
